<template>
  <div
    id="page-login"
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <template #no-body>
          <div class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center bg-white">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <img
                  src="@/assets/images/logo/ubunbase_login.png"
                  alt="ubun base"
                  class="responsive"
                />
              </div>
              <div
                v-if="!passwordResetLinkSent"
                class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg"
              >
                <div class="p-8">
                  <h4 class="mb-4">
                    パスワード再設定
                  </h4>
                  <paragraph class="text-sm">
                    UbunBASEに登録されているメールアドレスを入力してください。
                    パスワード再設定用のURLをお送りします。
                    ※URLの有効期間はメール送信後30分間です。
                  </paragraph>
                  <ValidationForm
                    ref="forgetObserver"
                    as="form"
                  >
                    <email-field
                      v-model="email"
                      class="mt-8"
                      rules="required|email"
                      full-width
                      @keydown.enter="onKeydownEnter"
                    />
                    <vs-button
                      class="w-full my-8"
                      @click="onSendClick"
                    >
                      送信
                    </vs-button>
                  </ValidationForm>
                </div>
              </div>
              <div
                v-else
                class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg"
              >
                <div class="p-8">
                  <h4 class="mb-4">
                    パスワード再設定メールを送信しました
                  </h4>
                  <paragraph class="text-sm">
                    {{ email }} へパスワード再設定メールを送信しました。
                    しばらくしてもメールが届かない場合は、スパムフォルダをご確認ください。
                  </paragraph>
                </div>
              </div>
            </div>
          </div>
        </template>
      </vx-card>
    </div>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import EmailField from '@/components/fields/EmailField'
import Paragraph from '@/components/Paragraph'

export default {
  name: 'Forget',
  components: {
    Paragraph,
    EmailField
  },
  data () {
    return {
      email: '',
      passwordResetLinkSent: false
    }
  },
  computed: {
    ...mapState(['globalError', 'requestingStatus'])
  },
  watch: {
    globalError: {
      deep: true,
      handler ({ message }) {
        this.$vs.notify({
          position: 'top-center',
          color: 'danger',
          text: message,
          fixed: true
        })
      }
    }
  },
  methods: {
    ...mapActions('auth', ['sendPasswordResetEmail']),
    onKeydownEnter (event) {
      event.stopPropagation()
      event.preventDefault()
      // 日本語入力中のEnterキー操作は無効にする
      if (event.keyCode !== 13) return
      this.onSendClick()
    },
    async onSendClick () {
      const isValid = await this.$refs.forgetObserver.validate()
      if (!isValid.valid) return
      try {
        await this.sendPasswordResetEmail({ email: this.email })
        this.passwordResetLinkSent = true
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss"></style>
